import { call, put, select } from 'redux-saga/effects';
import { handleServerError } from 'store/alerts/actions';
import { fetchGiftCardsApi } from 'store/giftCards/api';
import {
  addGiftCards,
  addPopularGiftCards,
  receiveGiftCards,
  receivePopularGiftCards,
  setValue,
} from 'store/giftCards/actions';
import { giftCardsSelector, popularGiftCardsSelector } from 'store/giftCards/selectors';

const PER_PAGE = 20;

function* fetchCategoriesWorker({ payload }) {
  const { selectedCategories, popularOnly, nextPage } = payload;

  const method = (() => {
    if (popularOnly && nextPage) return addPopularGiftCards;
    if (popularOnly && !nextPage) return receivePopularGiftCards;
    if (nextPage) return addGiftCards;

    return receiveGiftCards;
  })();

  try {
    yield put(
      setValue(
        popularOnly
          ? {
              isPopularGiftCardsLoaded: !!nextPage,
              isPopularGiftCardsLoading: true,
            }
          : {
              isGiftCardsLoaded: !!nextPage,
              isGiftCardsLoading: true,
            },
      ),
    );

    const giftCards = yield select(popularOnly ? popularGiftCardsSelector : giftCardsSelector);
    const giftCard = giftCards[giftCards.length - 1];

    const { data } = yield call(fetchGiftCardsApi, {
      last_product_id: nextPage && giftCard?.code ? giftCard?.code : null,
      limit: PER_PAGE,
      categories: selectedCategories.map(category => category.code).join(','),
      popular_only: popularOnly,
    });
    const items = data?.data || [];

    yield put(method({ items, isLeft: items.length === PER_PAGE }));
  } catch (error) {
    yield put(handleServerError(error));
    yield put(method({ items: [], isLeft: false }));
  }
}

export default fetchCategoriesWorker;
